import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Card as CardBase } from '@leroy-merlin-br/backyard-react-ui'

const inputsWrapperStyles = ({ theme }) => css`
  label: inputs-wrapper;

  margin: ${theme.spacings.giga} 0;
`

const regionSelectStyles = () => css`
  label: region-select;

  position: relative;
`

const cardStyles = () => css`
  label: card;

  text-align: center;

  & > div:last-of-type {
    overflow-y: unset;
  }
`

const titleStyles = ({ theme }) => css`
  label: title;

  font-size: ${theme.typography.headings.tera.fontSize};
  line-height: ${theme.typography.headings.tera.lineHeight};
  font-weight: ${theme.font.weight.bold};
`

export const RegionSelect = styled('div')(regionSelectStyles)
export const InputsWrapper = styled('div')(inputsWrapperStyles)
export const Card = styled(CardBase)(cardStyles)
export const Title = styled('strong')(titleStyles)
